import { STORE_CUSTOMIZATION } from './constants';
import { getStoreType } from './getStoreType';

export const isB2BStore = () => {
  return getStoreType() === STORE_CUSTOMIZATION.B2B;
};
